export enum LocalStorageKey {

	// ---------- Portfolio Library ----------
	SortHeaderMyPortfolios = 'sortHeaderMyPortfolios',
	SortHeaderSentToMe = 'sortHeaderSentToMe',
	SortHeaderSentToOthers = 'sortHeaderSentToOthers',

	// ---------- SSO ----------
	SsoInitiatedFrom = 'ssoInitiatedFrom',
	ExtSso = 'extsso',
	UseOkta = 'USE_OKTA',
	PublicAppLogin = 'PUBLIC_APP_LOGIN',

	// ---------- Portfolio Editor ----------
	EnableNewPortfolioEditor = 'enableNewPortfolioEditor',

	// ----------- Monitoring ---------------
	VisibleColumns = 'visibleColumns',

	// ---------- Other ----------
	ShowDeprecatedBrowserNotification = 'showDeprecatedBrowserNotification',
	FactorWorkbenchDisclaimerAccepted = 'FACTOR_WORKBENCH_DISCLAIMER_ACCEPTED',

	// ---------- Mocks ----------
	ModelsBrowseMockApi = 'modelsBrowseMockApi',
	CmaDebug = 'CmaDebug',
	MockPartnerApiSaveSuccess = 'mockPartnerApiSaveSuccess',
	MockCountry = 'mockCountry',
	MockWealthWeb = 'mockWealthWeb',
	MockPartnerApi = 'mockPartnerApi',
	MockPasApi = 'mockPasApi',
	MockExtPartnerBatchGet = 'mockExtPartnerBatchGet',

	// ---------- Portfolio Monitoring ----------
	PreviouslyAppliedRules = 'previouslyAppliedRules',


	// ---------- External Partner ----------
	ExternalPartner = 'externalPartner',
}

